<template>
  <div>
    <el-row>
      <el-col>
        <el-row :span="24">
          <el-col
            :span="24"
            style="text-align: center;font-size: 50px;color: #fff;;font-weight: bold;padding-top:80px;text-shadow: rgb(0, 0, 0) 5px 2px 6px;"
          >
            {{ title }}
          </el-col>
          <el-col
            :span="18"
            style="margin-left: 30px;text-align: left;font-size: 18px;color: #fff;margin-bottom: 40px;"
          >
          </el-col>
          <el-col :span="14" class="index_bg" :offset="5">
            <el-col :span="11" class="index_bj_content">
              <div @click="routerTo1()">
                <el-col :span="5"
                  ><img
                    src="../../../assets/constractor_icon.png"
                    alt=""
                    style="width:44px;margin: 10px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >建设单位</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >单位注册、登录、密码修改、项目报审主体、查看意见、下载报告</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <el-col :span="11" class="index_bj_content">
              <div @click="routerTo2()">
                <el-col :span="5"
                  ><img
                    src="../../../assets/suevey_icon.png"
                    alt=""
                    style="width:44px;margin: 10px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >勘察单位</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >单位注册、登录、密码修改、项目报审、回复、下载图纸</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <el-col :span="11" class="index_bj_content">
              <div @click="routerTo3()">
                <el-col :span="5"
                  ><img
                    src="../../../assets/design_icon.png"
                    alt=""
                    style="width:44px;margin: 20px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >设计单位</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >单位注册、登录、密码修改、设计项目报审、回复、下载图纸</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <el-col :span="11" class="index_bj_content">
              <div @click="routerTo4()">
                <el-col :span="5"
                  ><img
                    src="../../../assets/examination_icon.png"
                    alt=""
                    style="width:44px;margin: 10px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >审图机构</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >项目接审、分配、审查图纸、出具意见、综合统计</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <el-col :span="11" class="index_bj_content">
              <div @click="routerTo5()">
                <el-col :span="5"
                  ><img
                    src="../../../assets/supervice_icon.png"
                    alt=""
                    style="width:44px;margin: 10px 0px;"
                /></el-col>
                <el-col :span="18" style="height: 74px;">
                  <el-col
                    :span="24"
                    style="font-weight: bold;font-size: 20px;color: #333;"
                    >主管部门</el-col
                  >
                  <el-col
                    :span="24"
                    style="font-size:12;color: #666;margin-top: 6px;"
                    >项目查询、统计报表、系统配置、质量监督</el-col
                  >
                </el-col>
                <span class="triangle"><i class="el-icon-edit"></i></span>
              </div>
            </el-col>
            <!-- <el-col :span="11" class="index_bj_content">
							<router-link :to="''">
								<el-col :span="5"><img src="../../../assets/user_icon.png" alt="" style="width:44px;margin: 10px 0px;"></el-col>
								<el-col :span="18" style="height: 74px;">
									<el-col :span="24" style="font-weight: bold;font-size: 20px;color: #333;">社会公众</el-col>
								</el-col>
								<span class="triangle"><i class="el-icon-edit"></i></span>
							</router-link>
						</el-col> -->
          </el-col>
          <el-col
            :span="24"
            style="text-align: center;font-size: 30px;color: #fff;position: fixed;bottom: 60px;text-shadow: rgb(0, 0, 0) 5px 2px 6px;"
          >
            技术支持单位：库傲（上海）信息科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;技术服务热线：021-55883521
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      title="温馨提示"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      style="text-align:left;font-size:18px;border-radius:10px;"
      width="1200px"
    >
      <div style="font-size:16px" class="dialogTitle">
        <p>
          1. 建设单位请在报审前阅读建设单位-办事指南-
          <span class="reportRange" @click="reportRange()"
            >《数字化多图联审的报审范围》</span
          >
        </p>
        <p>2. 各位报审单位用户初次使用审查系统请先下载操作指南以及审图插件。</p>
        <p>
          3.
          为了方便各位报审单位审图工作，减少错误操作，系统各个环节均有弹窗提示，务必仔细阅读并按要求进行操作，避免因为操作失误导致项目出现问题耽误您的时间。
        </p>
        <p>
          4. 系统提供在线客服，请按以下渠道联系我们描述您的问题，我们予以解答。
        </p>
        <p>5. 常用报审表格下载请在办事指南中查找。</p>
      </div>
      <el-row class="dialogBody">
        <el-col :span="4">
          <p>方式一：热线电话 <span style="color:#f3334a">(繁忙)</span></p>
          <p>4008-202-010</p>
        </el-col>
        <el-col :span="5">
          <p>方式二：技术咨询QQ群 <span style="color:#56dc48">(推荐)</span></p>
          <p>勘察设计苏州服务群<br />群号：728334399</p>
          <p><img src="../../../assets/dialog1.jpg" alt="" /></p>
        </el-col>
        <el-col :span="4">
          <p style="color:#fff">1</p>
          <p>苏州2勘察设计服务群<br />群号：276132090</p>
          <p><img src="../../../assets/dialog4.jpg" alt="" /></p>
        </el-col>
        <el-col :span="6">
          <p style="color:#fff">1</p>
          <p>数字审图苏州服务群<br />群号：659665581</p>
          <p><img src="../../../assets/dialog3.jpg" alt="" /></p>
        </el-col>
        <el-col :span="5">
          <p style="color:#fff">1</p>
          <p>苏州电子签章服务群<br />群号：605756690</p>
          <p><img src="../../../assets/dialog2.jpg" alt="" /></p>
        </el-col>
      </el-row>
      <el-row class="dialogBody">
        <el-col :span="17" :offset="4">
          <div class="grid-content">
            加群时请注明您的单位名称并修改昵称为：单位名称+姓名。
            以便于我们针对各单位提出的问题作出回复，以免耽误审图进度。
          </div>
          <!-- <div class="gri-content" style="color:#f3334a">系统维护时间为每天晚上的19点到20点，在此期间请勿操作，否则项目出现问题，后果请自负。</div> -->
          <div class="gri-content">
            服务时间：周一至周五 9:00~12:00 13:00~17:30
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button type="primary" @click="dialogFormVisible = false"
          >我已知晓</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      bg: "",
      dialogFormVisible: false,
      sysConfig: "/draw/sys/sysconfig",
      url: {
        sysFunctionsIntroduce: "/draw/sysFunctionsIntroduce"
      }
    };
  },
  mounted() {
    /*document.querySelector('body').setAttribute('style', ' background-image:url(' + require('../../assets/bj6.jpg') +
				');background-size: 100% 140%; background-repeat: no-repeat;')*/
    this.query_config();
    //document.querySelector('body').setAttribute('style', ' background-image:url(../../assets/bj.jpg)')
  },
  methods: {
    reportRange() {
      const link = document.createElement("a");
      link.href = "/upload/2019/12/16ed41ab7a2d7d681ce6689403c84bfe.pdf";
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
    },
    routerTo1() {
      this.$router.push({
        name: `censor_login-xz`,
        query: {
          Type: "censor"
        }
      });
    },
    routerTo2() {
      this.$router.push({
        name: `censor_login-xz`,
        query: {
          Type: "survey"
        }
      });
    },
    routerTo3() {
      this.$router.push({
        name: `censor_login-xz`,
        query: {
          Type: "design"
        }
      });
    },
    routerTo4() {
      this.$router.push({
        name: `drawing_login-xz`,
        query: {
          Type: "drawing"
        }
      });
    },
    routerTo5() {
      this.$router.push({
        name: `supersive_login-xz`,
        query: {
          Type: "supervise"
        }
      });
    },
    query_config() {
      this.$http
        .get(this.url.sysFunctionsIntroduce + "?code=portal_bg")
        .then(res => {
          document
            .querySelector("body")
            .setAttribute(
              "style",
              " background-image:url(" +
                res.data.result.data[0].url +
                "); background-repeat: no-repeat;"
            );
        });
      this.$http
        .get(this.url.sysFunctionsIntroduce + "?code=portal_title")
        .then(res => {
          this.title = res.data.result.data[0].content;
        });
    }
  }
};
</script>
<style scoped>
@import "../../../styles/css/index-cf.css";
@import "../../../styles/css/index-xz";
html,
body {
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/login/xuzhou/index-xz.vue